export default __webpack_public_path__ + "static/layout-anatomy-dark-f536a208358a3301fb7a015b29fdf960.png";